import React, {PureComponent} from "react"
import {Row, Col, Grid} from "react-bootstrap"
import styled from "styled-components"

import {connect} from "@irati/store"
import {ReduxState} from "@irati/store/types"
import {H2} from "@irati/ui/src/Headings"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import {RouterLink} from "@irati/ui/src/Link"
import padding from "@irati/ui/src/global/padding"
import {Para} from "@irati/ui/src/Labels"

import notFoundImage from "../../images/notFound.png"

interface Props extends InjectIntl {
  buttonHref?: string,
  buttonText?: string,
  isMobile: boolean,
  text?: string
}

interface StyledProps {
  isMobile: boolean
}

const Image = styled.img`
  max-width: 100%;
`

const StyledRow = styled(Row)`
  margin-top: 100px;
  text-align: center;
`

const StyledDiv = styled<StyledProps, "div">("div")`
  padding-top: ${({isMobile}) => (isMobile ? "0px" : "100px")};
`

const StyledPara = styled(Para)`
  padding: ${padding.base} 0 ${padding.small};
`

class NotFound extends PureComponent<Props> {
  static defaultProps = {
    text: "reward.notFound.text"
  }

  render() {
    const {buttonHref, buttonText, formatMessage, isMobile, text} = this.props

    return (
      <Grid>
        <StyledRow>
          {!isMobile &&
            <Col md={6} xs={12}>
              <Image
                alt={formatMessage({id: "reward.notFound.image"})}
                src={notFoundImage} />
            </Col>
          }
          <Col md={6} xs={12}>
            <StyledDiv isMobile={isMobile}>
              <H2>
                <FormattedMessage id="reward.notFound.title" />
              </H2>
              <StyledPara center large>
                <FormattedMessage id={text} />
              </StyledPara>
              {buttonHref && buttonText &&
                <RouterLink to={buttonHref}>
                  <Button primary>
                    <FormattedMessage id={buttonText} />
                  </Button>
                </RouterLink>
              }
            </StyledDiv>
          </Col>
        </StyledRow>
      </Grid>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isMobile: mq.lessThan.md
})

export default injectIntl(connect(mapStateToProps)(NotFound))
